<template>
    <div class="invoicesForm">
        <van-nav-bar
            title="发票信息"
            left-arrow
            @click-left="onClickLeft"
        />
        <div>
            <p class="invoices-tip">纸质发票将以快递到付方式邮寄给您</p>
            <div class="invoice-content">
                <van-form @submit="onSubmit"  ref="submitForm" >
                    <van-field name="invoiceType" label="发票类型">
                        <template #input>
                            <van-radio-group v-model="form.invoiceType" direction="horizontal"  @change="handleType()">
                            <van-radio name=1 class="mr-4">普通发票</van-radio>
                            <van-radio name=2 class="romSty">增值税专用发票</van-radio>
                            </van-radio-group>
                        </template>
                    </van-field>
                    <van-field name="form.invoiceTitleType" label="抬头类型">
                        <template #input>
                            <van-radio-group v-model="form.invoiceTitleType" direction="horizontal">
                            <van-radio name=2  :disabled="form.invoiceType==2" class="mr-4">个人</van-radio>
                            <van-radio name=1  class="romSty">单位</van-radio>
                            </van-radio-group>
                        </template>
                    </van-field>
                    <van-field
                        v-model="form.invoiceTitle"
                        label="发票抬头"
                        placeholder="请输入发票抬头"
                        maxlength=25
                        :rules="[{ validator, message: '' }]"
                    />
                    <van-field
                        v-model="form.taxNumber"
                        label="单位税号"
                        placeholder="请输入单位税号"
                        maxlength=25
                        v-if="form.invoiceTitleType ==1"
                        :rules="[{ validator, message: '' }]"
                    />
                    <van-field
                        v-model="form.bankName"
                        label="开户银行"
                        placeholder="请输入开户银行"
                        maxlength=25
                        v-if="form.invoiceType==2"
                        :rules="[{ validator, message: '' }]"
                    />
                     <van-field
                        v-model="form.bankAccount"
                        label="银行账号"
                        placeholder="请输入银行账号"
                        maxlength=25
                        v-if="form.invoiceType==2"
                        :rules="[{ validator, message: '' }]"
                    />
                     <van-field
                        v-model="form.registPhone"
                        label="注册电话"
                        placeholder="请输入注册电话"
                        type="text"
                        maxlength=15
                        v-if="form.invoiceType==2"
                        :rules="[{ validator:validateTel, message: '' }]"
                    />
                     <van-field
                        v-model="form.registAdress"
                        label="注册地址"
                        placeholder="请输入注册地址"
                        maxlength=50
                        v-if="form.invoiceType==2"
                        :rules="[{ validator, message: '' }]"
                    />
                     <van-field
                        v-model="form.recipientName"
                        label="收件人姓名"
                        placeholder="请输入收件人姓名"
                        maxlength = 25
                        :rules="[{ validator, message: '' }]"
                    />
                     <van-field
                        v-model="form.recipientPhone"
                        label="手机号码"
                        maxlength=11
                        minlength=11
                        type="tel"
                        placeholder="请输入收件人手机号码"
                        :rules="[{ validator:validatePhone, message: '' }]"
                    />

                     <van-field
                        v-model="form.recipientAddress"
                        label="收件地址"
                        placeholder="请输入收件人详细地址"
                        maxlength=50
                        :rules="[{ validator, message: '' }]"
                    />
                     <van-field
                        v-model="form.recipientEmail"
                        label="邮箱地址"
                        placeholder="请输入收件人邮箱地址（非必填）"
                        maxlength=25
                        
                         :rules="[{ validator:validateEmail, message: '' }]"
                    />
                    <div class="submitBtn">
                        <van-button round block type="info" native-type="submit">提交</van-button>
                    </div>
                </van-form>
            </div>
        </div>
        <van-dialog v-model="dialogShow" title="" show-cancel-button class="errorTip" confirmButtonText="确定" cancelButtonText="取消" @confirm="handleConfirm()"> 
            <img src="../../../assets/images/account/errorTip.png" />
            <p class="tip-title">提示</p>
            <p class="tip-text">{{text1}}</p>
        </van-dialog>
    </div>
</template>

<script>
import { Toast } from 'vant';
export default {
    name: "invoicesform",
    data() {
        return {
            dialogShow:false,
            text1:'已填写信息将不被保存，是否返回',
            form:{
                invoiceType:"1",  //发票类型 1普通发票 2增值税专用发票
                invoiceTitleType:"2", //抬头类型 1单位 2个人
                invoiceTitle:'',
                taxNumber:'',
                bankName:'',
                bankAccount:'',
                registPhone:'',
                recipientName:'',
                recipientPhone:'',
                recipientAddress:'',
                recipientEmail:'',
                orderId:0,
            }
        };
    },
    components: {},
    methods: {
        validator(val) {
            return !/^\s*$/g.test(val);
        },
        validatePhone(val){
            return /^1(?:3[0-9]|4[5-9]|5[0-9]|6[12456]|7[0-8]|8[0-9]|9[0-9])[0-9]{8}$/.test(val)
        },
        validateTel(val){
            return (/^1(?:3[0-9]|4[5-9]|5[0-9]|6[12456]|7[0-8]|8[0-9]|9[0-9])[0-9]{8}$/.test(val) || /^0[1-9][0-9]{1,2}-[2-8][0-9]{6,7}$/.test(val) )
        },
        validateEmail(val){
            if(val){
                return /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(val)
            }else{
                return true
            }
        },
        onClickLeft() {
            this.text1 = '已填写信息将不被保存，是否返回';
            this.dialogShow = true;
        },
        handleConfirm(){
            if(this.text1=='提交后发票信息将无法更改'){
                this.submitData();
            }else{
                this.$router.go(-1);
            }
        },
        onSubmit(values) {
            this.dialogShow = true ;
            this.text1 = '提交后发票信息将无法更改';
        },
        // 发票类型
        handleType(){
            if(this.form.invoiceType==2){
                this.form.invoiceTitleType = '1';
            }
        },
        submitData(){
            const that = this;
            this.$api.invoice.postData(this.form).then((res)=>{
                if(res.code==0){
                    Toast({
                        message:'申请成功',
                        type:"success",
                        className:'successTY',
                        onClose:function(){
                            that.$router.push({
                                path: '/orderpage',
                            })
                        }
                    });
                }else{
                    Toast.fail(res.data.message);
                } 
            })
        }
    },
    created(){
        this.form.orderId = this.$route.query.id;
    }
};
</script>

<style scoped lang="stylus">
@import '../asset/css/invoices.styl'
.successTY{
    background:rgba(0,0,0,.7);
}

</style>
